export default __webpack_public_path__ + "static/media/kul_logo.a16dbda0.png";